import * as React from "react";
import classNames from "classnames";
import { Dispatch } from "redux";
import { connect } from "react-redux";
import { StoreState } from "../../reducers/root-reducer";
import { WithStyles, Theme, createStyles, withStyles } from "@material-ui/core";
import { translate, InjectedTranslateProps } from "react-i18next";

import { format, formatDate } from "../../util/date-utility";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import AccessTime from "@material-ui/icons/AccessTime";
import { setActiveTime } from "../../actions/store/overview-actions";
import { Reservation } from "../../api/reservations";
import { Table } from "../../api/tables";

export interface TimeSelectProps {}

interface State {
	timeSelectAnchor: HTMLElement;
	activeTimeName: string;
	availableTimes: Array<any>;
}

interface ConnectedTimeSelectProps extends WithStyles<typeof styles> {
	tables: Table[];
	reservations: Reservation[];
	activeTimeId: string;
	activeAreaId: string;
	layout: "desktop" | "tablet" | "phone";
	setActiveTime: (id: string) => void;
	showAlleAreasToggle: boolean;
	syncWithArea?: boolean;
	isListView?: boolean;
}

type Props = TimeSelectProps &
	ConnectedTimeSelectProps &
	InjectedTranslateProps;

export class TimeSelect extends React.Component<Props, State> {
	public state: State = {
		timeSelectAnchor: null,
		activeTimeName: '',
		availableTimes: []
	};

	componentDidMount() {
		this.generateTimeList(null);
		// this.setActiveTimeName(this.props.activeTimeId);
	}

	componentWillReceiveProps(nextProps: Props) {
		this.generateTimeList(nextProps);
		//if (this.props.activeTimeId !== nextProps.activeTimeId) {
			// this.setActiveTimeName(nextProps.activeTimeId);
		//}
	}

	generateTimeList = (nextProps: Props) => {
		const { reservations, activeTimeId, activeAreaId, tables, showAlleAreasToggle, isListView, syncWithArea } = (nextProps) ? nextProps : this.props;

		var areas:string[];

		var isCurrentViewList = isListView !== undefined ? isListView : false;
		var areaSync = syncWithArea !== undefined ? syncWithArea : false;
		
		if(isCurrentViewList && showAlleAreasToggle) {
			// zweimal ändern!
			areas = [
				"64eeed7a1b169e675e05e30f",
				"64eeedaa1b169e675e05e315",
				"64eeedb61b169e675e05e317",
				"64eeedc51b169e675e05e319",
				"64eeeddb1b169e675e05e31d"
			];
		} else {
			areas = [activeAreaId];
		}
		
		var getTimesByActiveArea = isListView !== undefined ? isListView : false;
		var timeArray: Array<any> = [];

		if(areaSync) {
			areas.forEach(function (a, index) {
				const tableIdsInArea: string[] = tables.filter(table => table.areaId === a).map(table => table.id);
				reservations.filter(reservation => tableIdsInArea.indexOf(reservation.tableId) !== -1).forEach(function (item, index) {
					let time: String = format(item.time, "HH:mm"); //mm
					let timeId: String = format(item.time, "HH-mm"); //mm
					if(item.time){
						if(!timeArray.find(o => o.name === time)){
							timeArray.push({id: timeId, name: time});
						}
					}
				});
			});
		} else {
			reservations.forEach(function (item, index) {
				let time: String = format(item.time, "HH:mm"); //mm
				let timeId: String = format(item.time, "HH-mm"); //mm
				if(item.time){
					if(!timeArray.find(o => o.name === time)){
						timeArray.push({id: timeId, name: time});
					}
				}
			});
		}
		timeArray.sort( this.compareByName );
		timeArray.unshift({id: "24h", name: "Ganztags"});
		timeArray.unshift({id: "", name: "Kein Filter"});
		this.setState({
			availableTimes: timeArray
		});

		// set Name
		this.setActiveTimeName(timeArray, activeTimeId);

		return;
	};

	setActiveTimeName = (availableTimes: Array<any> , id: string) => {
		// const { availableTimes } = this.state;

		const activeTime = availableTimes.find(time => time.id === id);

		if (activeTime) {
			this.setState({
				activeTimeName: activeTime.name 
			});
		} else {
			if(availableTimes.length > 0){
				const firstListItem = availableTimes[0];
				
				this.setState({
					activeTimeName: firstListItem.name
				});
				this.props.setActiveTime(firstListItem.id);
			} else {
				this.setState({
					activeTimeName: "Kein Filter"
				}); 
				this.props.setActiveTime("");
			} 
		}
	};

	handleTimeSelectClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		this.setState({ timeSelectAnchor: event.currentTarget });
	};

	handleTimeSelectClose = () => {
		this.setState({ timeSelectAnchor: null });
	};

	handleTimeChange = (
		event: React.ChangeEvent<HTMLSelectElement>,
		value: string
	) => {
		this.props.setActiveTime(value);
	};

	handleTimeSelectItemClick = (id: string) => {
		this.props.setActiveTime(id);
	};

	compareByName = ( a: any, b: any ) => {
		if ( a.name < b.name ){
		  return -1;
		}
		if ( a.name > b.name ){
		  return 1;
		}
		return 0;
	}
	
	public render() {
		const { classes, layout, reservations } = this.props;
		const { activeTimeName, timeSelectAnchor, availableTimes } = this.state;

		return (
			<React.Fragment>
					<Button
						className={classNames(
							classes.dropdownButton,
							layout === "phone" ? classes.btnMobile : classes.btnDesktop,
							classes.timeSelectButton
						)} 
						variant={layout === "phone" ? "flat" : "outlined"}
						color="inherit"
						onClick={this.handleTimeSelectClick}
					>
						<AccessTime className={classes.iconSmall} />
						<span className={classNames(
							layout === "phone" ? classes.btnLabelMobile : classes.btnLabelDesktop,
							classes.iconButtonLabel
						)}>
							{activeTimeName}
						</span>
					</Button>
				<Menu
					anchorEl={timeSelectAnchor}
					open={Boolean(timeSelectAnchor)}
					onClick={this.handleTimeSelectClose}
				>
					{availableTimes.map(t => (
						<MenuItem
							key={t.id}
							onClick={() =>
								this.handleTimeSelectItemClick(t.id)
							}
						>
							{t.name}
						</MenuItem>
					))}
				</Menu>
			</React.Fragment>
		);
	}
} 

const mapStateToProps = (state: StoreState) => ({
	activeAreaId: state.overviewActiveAreaId,
	tables: state.tables,
	reservations: state.reservations,
	activeTimeId: state.overviewActiveTimeId,
	showAlleAreasToggle: state.overviewAllAreasToggle,
	layout: state.layout
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	setActiveTime: (id: string) => dispatch(setActiveTime(id))
});

const styles = (theme: Theme) =>
	createStyles({
		iconSmall: {
			fontSize: 20
		},
		iconButtonLabel: {
			textTransform: "none",
			paddingLeft: 6,
			paddingRight: 6
		},
		timeSelectButton: {
			marginRight: 8
		},
		dropdownButton: {
			paddingLeft: 8,
			paddingRight: 8,
			borderColor: "rgba(255, 255, 255, 0.3)"
		},
		areaSelect: {},
		btnMobile: {
			marginRight: "0px",
			paddingLeft: "3px",
			paddingRight: "3px"
		},
		btnDesktop: {},
		btnLabelMobile: { 
			overflow: "hidden",
			whiteSpace: "nowrap",
			paddingLeft: "2px",
			paddingRight: "0px"
		},
		btnLabelDesktop: {}
	});

export const ConnectedTimeSelect = translate("translations")(
	withStyles(styles)(
		connect(
			mapStateToProps,
			mapDispatchToProps
		)(TimeSelect)
	)
);
